:host {
  --uui-banner-toast-body-font-color: var(--uui-theme-on-core-600);
  --uui-banner-toast-title-font-color: var(--uui-theme-on-core-600);
  --uui-banner-toast-title-font-weight: var(--uui-font-weight-bold);
  --uui-banner-toast-padding: 1.25em;
  --uui-banner-toast-body-margin: 0.5em 0 0 0;
  --uui-banner-toast-border-top-color: var(--uui-theme-core-500);
  --uui-banner-toast-background-color: var(--uui-theme-success-500);
  --uui-banner-toast-icon-url: url('data:image/svg+xml; utf8, <svg fill="%23003b75" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"/></svg>');
}

:host {
  font-family: var(--uui-primary-font-family);
}

:host(:not([visible])) {
  display: none;
}

:host > .uui-toast-container {
  padding: var(--uui-banner-toast-padding);
  border-top: 0.375em solid var(--uui-banner-toast-border-top-color);
  background-color: var(--uui-banner-toast-background-color);
  border-radius: 0.25em;
  width: auto;
  max-width: 100%;
  font-size: 0.875rem;
  pointer-events: auto;
  background-clip: padding-box;
  border: none;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

[data-mode="success"] {
  --uui-banner-toast-border-top-color: var(--uui-theme-success-500);
  --uui-banner-toast-background-color: var(--uui-theme-success-400);
  --uui-banner-toast-icon-url: url('data:image/svg+xml; utf8, <svg fill="%230d725e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"/></svg>');
}

[data-mode="caution"] {
  --uui-banner-toast-border-top-color: var(--uui-theme-warning-500);
  --uui-banner-toast-background-color: var(--uui-theme-warning-400);
  --uui-banner-toast-icon-url: url('data:image/svg+xml; utf8, <svg fill="%23b37400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"/></svg>');
}

[data-mode="error"] {
  --uui-banner-toast-border-top-color: var(--uui-theme-error-500);
  --uui-banner-toast-background-color: var(--uui-theme-error-300);
  --uui-banner-toast-icon-url: url('data:image/svg+xml; utf8, <svg fill="%23ca110f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"/></svg>');
}

[data-mode="notification"] {
  --uui-banner-toast-border-top-color: var(--uui-theme-information-600);
  --uui-banner-toast-background-color: var(--uui-theme-information-400);;
}

[data-position="relativeposition"] {
  position: relative;
}

[data-position="topright"] {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 99999;
}

[data-position="topleft"] {
  position: fixed;
  left: 1rem;
  right: 1rem;
  z-index: 99999;
}

[data-position="bottomleft"] {
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  z-index: 99999;
}

[data-position="bottomright"] {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 99999;
}

[data-visible="isvisible"] {
  display: block;
}

[data-visible="ishidden"] {
  display: none;
}

.toast-header-text {
  color: var(--uui-banner-toast-title-font-color);
  font-weight: var(--uui-banner-toast-title-font-weight);
  margin-bottom: 0;
  margin-top: 0;
}

/*
  unable to change the default paragraph styles without using !important
*/
slot::slotted(*) {
  color: var(--uui-banner-toast-title-font-color) !important;
  margin: var(--uui-banner-toast-body-margin) !important;
  font-size: var(--uui-small-font-size) !important;
}

.uui-toast-header-close-btn {
  margin-inline-start: auto;
  display: inline;
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  font-size: 1.25em;
}

.uui-toast-header-close-btn svg {
  fill: var(--uui-theme-on-core-600);
}

.toast-header-container {
  display: flex;
}

.toast-header-container::before {
  content: var(--uui-banner-toast-icon-url);
  margin-right: 0.625em;
  position: relative;
  top: 0.155em;
  height: 1.25em;
  width: 1.25em;
}

/*
styles for contextual toasts
*/
:host([type="contextual"]) {
  --uui-banner-toast-title-font-weight: var(--uui-font-weight-normal);
  --uui-banner-toast-padding: 1.75em 2em;
}
:host([type="contextual"]) > div {
  border-top: none;
}

:host([type="contextual"]) .uui-toast-header-close-btn {
  display: none;
}

:host([type="contextual"]) slot {
  display: none;
}
